import React from "react";
import CEHeader from "../../../components/Compliance Certificates/CE/CEHeader";
import CEInfoContainer from "../../../components/Compliance Certificates/CE/CEInfoContainer";

const CE = () => {
  return (
    <div>
      <CEHeader />
      <CEInfoContainer />
    </div>
  );
};

export default CE;
